import { Injectable, inject, signal } from '@angular/core';
import { UserStorageService } from './user-storage.service';

export type MapTapMode = 'interaction' | 'browse';

const MAP_TAP_MODE_KEY = 'map-tap-mode';
const DEFAULT_MODE: MapTapMode = 'interaction';

/**
 * Controls what tapping a building on the map does: create a new interaction
 * ('interaction' mode) or open the address's existing history ('browse' mode).
 * Persisted per user so the choice survives a refresh/relaunch.
 */
@Injectable({ providedIn: 'root' })
export class MapModeService {
  private readonly userStorage = inject(UserStorageService);

  readonly mode = signal<MapTapMode>(this.loadInitial());

  setMode(mode: MapTapMode): void {
    this.mode.set(mode);
    this.userStorage.setItem(MAP_TAP_MODE_KEY, mode);
  }

  private loadInitial(): MapTapMode {
    const stored = this.userStorage.getItem(MAP_TAP_MODE_KEY);
    return stored === 'browse' ? 'browse' : DEFAULT_MODE;
  }
}
